// import cn from "classnames";
// import { useContext, useEffect } from "react";
// import useReduxState from "@hooks/useReduxState";
// import { useQuery } from "@apollo/client";
// import type { Socket } from "socket.io-client";
// import { SocketContext } from "@context/socket";
// import { toastErrorMessage } from "@utils/utils";

import Layout from "@components/layout";
import styles from "./TermsOfService.module.scss";

export default function TermsOfService(): JSX.Element {
  //   const socket: Socket = useContext(SocketContext);

  //   const trailAnimation = useTrail(Views.length, {
  //     from: { opacity: 0, transform: 'translateY(50%)' },
  //     to: { opacity: 1, transform: 'translateY(0%)' },
  //     pause: !fetched,
  //   });

  return (
    <Layout title="terms of service">
      <div className={styles.container}>
        <h1>Placeholder for Terms of Service</h1>
      </div>
    </Layout>
  );
}
